var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "landing__news" }, [
    _c("div", { class: _vm.prevButtonClass, on: { click: _vm.prev } }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "news__section" },
      [
        _c(
          "transition-group",
          { attrs: { name: "slide-fade", tag: "div" } },
          _vm._l(_vm.slides, function(slide, index) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: slide.display,
                    expression: "slide.display"
                  }
                ],
                key: index,
                staticClass: "news__slide"
              },
              _vm._l(slide.news, function(item) {
                return _c("div", { staticClass: "news" }, [
                  _c("h2", [_vm._v(_vm._s(item.publishDate))]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("h5", { staticClass: "news__header" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.title) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(item.shortDescription) }
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "a",
                      { staticClass: "link", attrs: { href: item.link } },
                      [_vm._v("loe edasi")]
                    )
                  ])
                ])
              })
            )
          })
        ),
        _vm._v(" "),
        _c("div", { staticClass: "news__slide news__slide--invisible" }, [
          _c("div", { staticClass: "news" }, [
            _c("h2", [_vm._v(_vm._s(_vm.longestNews.publishDate))]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h5", { staticClass: "news__header" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.longestNews.title) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("p", {
              domProps: { innerHTML: _vm._s(_vm.longestNews.shortDescription) }
            }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [
              _c(
                "a",
                { staticClass: "link", attrs: { href: _vm.longestNews.link } },
                [_vm._v("loe edasi")]
              )
            ])
          ])
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { class: _vm.nextButtonClass, on: { click: _vm.next } })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00d92006", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00d92006","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./www/js/Components/NewsSlider/NewsSlider.vue
// module id = 518
// module chunks = 1